import { render, staticRenderFns } from "./SoftwareDevelopment.vue?vue&type=template&id=430b2b17&scoped=true&"
var script = {}
import style0 from "./SoftwareDevelopment.vue?vue&type=style&index=0&id=430b2b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b2b17",
  null
  
)

export default component.exports